/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Click_To_BrowseInputs */

const en_common_click_to_browse = /** @type {(inputs: Common_Click_To_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`or click to browse from your computer`)
};

const es_common_click_to_browse = /** @type {(inputs: Common_Click_To_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`o haz clic para buscar en tu computadora`)
};

/**
* | output |
* | --- |
* | "or click to browse from your computer" |
*
* @param {Common_Click_To_BrowseInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_click_to_browse = /** @type {((inputs?: Common_Click_To_BrowseInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Click_To_BrowseInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_click_to_browse(inputs)
	return en_common_click_to_browse(inputs)
});